module.exports = __webpack_public_path__ + "img/csr_swiper_02_01.369646de.jpg";